/**
 * @fileoverview gRPC-Web generated client stub for documentsource
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: documentsource/documentsource.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var authz_annotations_pb = require('../authz/annotations_pb.js')
const proto = {};
proto.documentsource = require('./documentsource_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.documentsource.DocumentSourceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.documentsource.DocumentSourcePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.documentsource.DescribeSourceRequest,
 *   !proto.documentsource.SourceInfo>}
 */
const methodDescriptor_DocumentSource_DescribeSource = new grpc.web.MethodDescriptor(
  '/documentsource.DocumentSource/DescribeSource',
  grpc.web.MethodType.UNARY,
  proto.documentsource.DescribeSourceRequest,
  proto.documentsource.SourceInfo,
  /**
   * @param {!proto.documentsource.DescribeSourceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.documentsource.SourceInfo.deserializeBinary
);


/**
 * @param {!proto.documentsource.DescribeSourceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.documentsource.SourceInfo)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.documentsource.SourceInfo>|undefined}
 *     The XHR Node Readable Stream
 */
proto.documentsource.DocumentSourceClient.prototype.describeSource =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/documentsource.DocumentSource/DescribeSource',
      request,
      metadata || {},
      methodDescriptor_DocumentSource_DescribeSource,
      callback);
};


/**
 * @param {!proto.documentsource.DescribeSourceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.documentsource.SourceInfo>}
 *     Promise that resolves to the response
 */
proto.documentsource.DocumentSourcePromiseClient.prototype.describeSource =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/documentsource.DocumentSource/DescribeSource',
      request,
      metadata || {},
      methodDescriptor_DocumentSource_DescribeSource);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.documentsource.ListNodesRequest,
 *   !proto.documentsource.ListNodesResponse>}
 */
const methodDescriptor_DocumentSource_ListNodes = new grpc.web.MethodDescriptor(
  '/documentsource.DocumentSource/ListNodes',
  grpc.web.MethodType.UNARY,
  proto.documentsource.ListNodesRequest,
  proto.documentsource.ListNodesResponse,
  /**
   * @param {!proto.documentsource.ListNodesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.documentsource.ListNodesResponse.deserializeBinary
);


/**
 * @param {!proto.documentsource.ListNodesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.documentsource.ListNodesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.documentsource.ListNodesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.documentsource.DocumentSourceClient.prototype.listNodes =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/documentsource.DocumentSource/ListNodes',
      request,
      metadata || {},
      methodDescriptor_DocumentSource_ListNodes,
      callback);
};


/**
 * @param {!proto.documentsource.ListNodesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.documentsource.ListNodesResponse>}
 *     Promise that resolves to the response
 */
proto.documentsource.DocumentSourcePromiseClient.prototype.listNodes =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/documentsource.DocumentSource/ListNodes',
      request,
      metadata || {},
      methodDescriptor_DocumentSource_ListNodes);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.documentsource.ResolveNodesRequest,
 *   !proto.documentsource.ResolveNodesResponse>}
 */
const methodDescriptor_DocumentSource_ResolveNodes = new grpc.web.MethodDescriptor(
  '/documentsource.DocumentSource/ResolveNodes',
  grpc.web.MethodType.UNARY,
  proto.documentsource.ResolveNodesRequest,
  proto.documentsource.ResolveNodesResponse,
  /**
   * @param {!proto.documentsource.ResolveNodesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.documentsource.ResolveNodesResponse.deserializeBinary
);


/**
 * @param {!proto.documentsource.ResolveNodesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.documentsource.ResolveNodesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.documentsource.ResolveNodesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.documentsource.DocumentSourceClient.prototype.resolveNodes =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/documentsource.DocumentSource/ResolveNodes',
      request,
      metadata || {},
      methodDescriptor_DocumentSource_ResolveNodes,
      callback);
};


/**
 * @param {!proto.documentsource.ResolveNodesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.documentsource.ResolveNodesResponse>}
 *     Promise that resolves to the response
 */
proto.documentsource.DocumentSourcePromiseClient.prototype.resolveNodes =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/documentsource.DocumentSource/ResolveNodes',
      request,
      metadata || {},
      methodDescriptor_DocumentSource_ResolveNodes);
};


module.exports = proto.documentsource;

